import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { FilterModel } from "./FilterModel";
import { Injectable } from "@angular/core";

@Injectable()
export class OrdersFilterModel extends FilterModel {
  public static readonly All: any = {
    orderState: [
      CubiqTS.OrderState.ACTIVE,
      CubiqTS.OrderState.TRIGGERED,
      CubiqTS.OrderState.MANUAL_PRICING,
      CubiqTS.OrderState.ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.PENDING,
      CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.CANCEL_ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.EXPIRY_ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.TRIGGERED_EXPIRY_ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.IN_MODIFICATION,
      CubiqTS.OrderState.MIGRATION_ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.SUSPENDED,
    ],
  };

  public static readonly Inbox: any = {
    orderState: [
      CubiqTS.OrderState.ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.CANCEL_ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.EXPIRY_ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.TRIGGERED_EXPIRY_ACCEPTANCE_NEEDED,
      CubiqTS.OrderState.MIGRATION_ACCEPTANCE_NEEDED,
    ],
  };

  public get(requested: string): any {
    if (`inbox` === requested) {
      return OrdersFilterModel.Inbox;
    }

    return OrdersFilterModel.All;
  }
}
